import {ChangeDetectionStrategy, Component, inject, input, signal} from "@angular/core";
import {finalize} from "rxjs";
import {PanelService} from "../../services/panel.service";
import {TableColumnManagerDirective} from "../../directives/table-column-manager.directive";
import {TableColumnPickerComponent} from "../table-column-picker/table-column-picker.component";
import {TableColumnToggle} from "../../models/table-column-option.model";

const COLUMN_PICKER_PANEL_CONFIG = {
  width: 240,
  position: {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
    offsetY: 4
  }
};

// Goes inside a header .th of a [tableColumnManager] header; column/group name the setting that renders that .th (no column on pinned cells)
require('./table-column-insert-button.scss');
@Component({
  standalone: false,
  selector: 'app-table-column-insert-button',
  templateUrl: './table-column-insert-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Keeps the button shown while the picker is anchored to it
  host: {'[class.open]': 'isPickerOpen()'}
})
export class TableColumnInsertButtonComponent {
  readonly column = input<string>();
  readonly group = input('columns');

  readonly isPickerOpen = signal(false);

  private readonly tableColumnManager = inject(TableColumnManagerDirective);
  private readonly panelService = inject(PanelService);

  openPicker(event: MouseEvent) {
    event.stopPropagation();
    this.isPickerOpen.set(true);

    this.panelService.open(TableColumnPickerComponent, event, this.tableColumnManager.getPickerData(this.group(), this.column()), COLUMN_PICKER_PANEL_CONFIG)
      .afterClose$
      // finalize: afterClose$ completes without a value when the panel is disposed from outside
      .pipe(finalize(() => this.isPickerOpen.set(false)))
      .subscribe((toggle: TableColumnToggle | null | undefined) => {
        if (toggle) {
          this.tableColumnManager.toggleColumn(toggle, this.group(), this.column());
        }
      });
  }

  // The button is its own drag source, so pressing it can't start the header cell's column drag
  preventDrag(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
}
